// src/pages/QuanTri.js
import React, { useCallback, useEffect, useState } from "react";
import AdminPanel from "../components/AdminPanel";
import ViecChuNha from "../components/ViecChuNha";
import KhoAnh from "../components/KhoAnh";
import SaoLuu from "../components/SaoLuu";
import SoTheoDoi from "../components/SoTheoDoi";
import KhoanCoDinh from "../components/KhoanCoDinh";
import { fetchData } from "../services/api";
import { useThongBao, ThongBao } from "../vo";

// ============================================================
// 🏷️ BẢN ĐANG CHẠY
// ------------------------------------------------------------
// Trả lời đúng một câu hỏi, nhưng là câu hay bị đoán mò nhất mỗi lần
// deploy: "cái tôi đang nhìn có phải bản mới không?"
//
// Ngày 07/09/2026 đã có một buổi chiều mất công vì câu đó: mã đã sửa và
// đã đẩy lên, `git pull` xong, `git log` báo đúng số hiệu mới — nhưng thử
// thì vẫn lỗi, vì thư mục `build` chưa được dựng lại. Suýt đi viết mã sửa
// một lỗi không còn tồn tại.
//
// Con số dưới đây được nhét vào lúc DỰNG, nên nó nằm trong chính bản mà
// trình duyệt đang chạy. Nó không thể nói dối. Đối chiếu với `git log` là
// biết ngay tầng nào còn cũ.
//
// Đuôi "+sua" nghĩa là bản này dựng từ mã có thay đổi chưa commit.
// Trên máy chủ thật thì KHÔNG được thấy đuôi đó.
// ============================================================
function BanDangChay() {
  const ban = process.env.REACT_APP_PHIEN_BAN;
  const luc = process.env.REACT_APP_LUC_DUNG;
  if (!ban) return null;
  return (
    <p
      style={{
        marginTop: 20,
        fontSize: 12,
        color: "#94a3b8",
        textAlign: "right",
      }}
      title="Số hiệu commit mà bản đang chạy được dựng ra từ đó"
    >
      Bản đang chạy: <code>{ban}</code>
      {luc ? ` · dựng lúc ${luc}` : ""}
    </p>
  );
}

// ============================================================
// QUẢN TRỊ HỆ THỐNG — chỉ admin vào được
// ------------------------------------------------------------
// Trang này gom mọi việc "làm sếp" lại một chỗ, tách hẳn khỏi trang dùng
// hằng ngày. Hiện có: quản lý thành viên, phân quyền, đặt lại mật khẩu.
//
// Sẽ thêm ở các đợt sau: Sổ theo dõi (hôm nay ai chưa điểm danh, nhật ký
// hoạt động, thang đo) — xem mục 5.3 tài liệu chân dung.
//
// ============================================================
// 📋 N5 (14/09/2026): VIỆC CỦA CHỦ NHÀ · KHO ẢNH · SAO LƯU
// ------------------------------------------------------------
// Anh chốt: việc riêng của chủ nhà nằm Ở ĐÂY, báo đỏ trên nút ⚙️ — không lên
// Bảng tin. Thứ tự cố ý: việc cần làm lên đầu (nhìn là biết có gì phải làm),
// rồi bảng thành viên (việc hay làm nhất), rồi kho ảnh, sao lưu.
//
// Làm xong một việc (tải về, dọn, tải sao lưu) thì đọc lại cả ba khung VÀ
// báo App đọc lại số đỏ — để con số không bao giờ nói dối.
// ============================================================
function QuanTri({ onDoiViecChuNha }) {
  const [viec, setViec] = useState([]);
  // null = đang tải · "loi" = tải hỏng · mảng/đối tượng = dữ liệu thật.
  // ⚠️ KHÔNG gộp "tải hỏng" vào "rỗng". Bản đầu gộp: tải hỏng thì Kho ảnh ghi
  // "Chưa có ảnh nào" — nói sai sự thật (anh Hùng hỏi "Kho ảnh ở đâu?" 14/09).
  const [khoAnh, setKhoAnh] = useState(null);
  const [saoLuu, setSaoLuu] = useState(null);
  // N6: ảnh sổ tay mẹo vặt — giữ lâu dài, không thuộc kho theo tháng (MV4).
  const [anhMeo, setAnhMeo] = useState(null);
  // N7: ảnh Sân chơi — cũng giữ lâu dài (SC5).
  const [anhSanChoi, setAnhSanChoi] = useState(null);
  // N8: danh mục khoản chi cố định + tháng này còn thiếu khoản nào (CN3).
  const [khoanCoDinh, setKhoanCoDinh] = useState(null);
  const { bao, noiBao } = useThongBao(5000);

  const taiLai = useCallback(() => {
    fetchData("quan-tri/viec-chu-nha").then((d) => setViec(d.viec)).catch(() => {});
    fetchData("quan-tri/kho-anh").then(setKhoAnh).catch(() => setKhoAnh("loi"));
    fetchData("quan-tri/anh-meo-vat").then(setAnhMeo).catch(() => setAnhMeo("loi"));
    fetchData("quan-tri/anh-san-choi").then(setAnhSanChoi).catch(() => setAnhSanChoi("loi"));
    fetchData("quan-tri/sao-luu").then(setSaoLuu).catch(() => setSaoLuu("loi"));
    fetchData("quan-tri/khoan-co-dinh").then(setKhoanCoDinh).catch(() => setKhoanCoDinh("loi"));
    if (onDoiViecChuNha) onDoiViecChuNha();
  }, [onDoiViecChuNha]);

  useEffect(() => {
    taiLai();
  }, [taiLai]);

  return (
    <>
      <ThongBao bao={bao} />
      <ViecChuNha viec={viec} />

      <div
        style={{
          marginBottom: 16,
          padding: "12px 16px",
          background: "#f1f5f9",
          borderLeft: "4px solid #64748b",
          borderRadius: 6,
          fontSize: 14,
          color: "#475569",
        }}
      >
        ⚙️ <strong>Khu vực quản trị.</strong> Những thay đổi ở đây ảnh hưởng
        tới cả nhà. Quyền cấp cho ai là có hiệu lực ngay lập tức.
      </div>

      <AdminPanel />

      {/* N8 (15/09): Sổ theo dõi ngay dưới bảng thành viên — cùng là chuyện "người trong nhà" */}
      <SoTheoDoi />
      <KhoanCoDinh tt={khoanCoDinh} onDoi={taiLai} noiBao={noiBao} />

      <KhoAnh ds={khoAnh} anhMeo={anhMeo} anhSanChoi={anhSanChoi} onDoi={taiLai} noiBao={noiBao} />
      <SaoLuu tt={saoLuu} onDoi={taiLai} noiBao={noiBao} />

      <BanDangChay />
    </>
  );
}

export default QuanTri;
